<template>
  <or-layout>
    <a-row :gutter="[16, 16]" type="flex" justify="space-between">
      <a-col :span="5">
        <!--<a-button type="primary" @click="tableAdd">创建</a-button>-->
      </a-col>
      <a-col>
        <a-form layout="inline">
          <a-form-item>
            <a-tree-select v-model="searchFrom.type_id" :treeData="typelist" style="width: 150px;"
              :replaceFields="{ children: 'children', title: 'name', key: 'name', value: 'id' }" placeholder="选择试卷分类"
              tree-default-expand-all allowClear></a-tree-select>
          </a-form-item>

          <a-form-item>
            <a-select v-model="searchFrom.is_newtest" placeholder="是否新生测试">
              <a-select-option :key="0" :value="0">不是新生</a-select-option>
              <a-select-option :key="1" :value="1">是新生</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select v-model="searchFrom.grade_id" placeholder="年级" style="width: 120px;">
              <a-select-option value>全部</a-select-option>
              <a-select-option v-for="(item) in gradeList" :key="item.id" :value="item.id">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select v-model="searchFrom.semester_id" placeholder="学期" style="width: 120px;">
              <a-select-option value>全部</a-select-option>
              <a-select-option v-for="(item) in semesterList" :key="item.id" :value="item.id">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-input placeholder="试卷名字" v-model="searchFrom.keyword" @keyup.enter="tableSearch"></a-input>
          </a-form-item>
          <a-form-item>
            <a-button :loading="loading" type="primary" htmlType="submit" icon="search" @click="tableSearch"></a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <div>
      <a-table :dataSource="data" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
        @change="onPaginationChange" bordered>

        <a-table-column key="name" title="试卷名称" data-index="name" />
        <a-table-column key="typename" title="试卷类型" data-index="typename" />
        <a-table-column key="score" title="试卷总分" data-index="score" />
        <a-table-column key="nickname" title="创建人" data-index="nickname" />
        <a-table-column key="create_time" title="创建时间" data-index="create_time" />
        <a-table-column key="teacher_check_flag" width="100px;" title="交叉批改">
          <template slot-scope="item">
            <span v-if="item.teacher_check_flag == 1">是</span>
            <span v-if="item.teacher_check_flag == 0">否</span>
          </template>
        </a-table-column>
        <a-table-column key="active" width="300px" title="操作">
          <template slot-scope="item">
            <a-button v-if="item.status == 0" @click="changeStatus({ id: item.id, status: 1 })" class="active_btn red"
              size="small" type="link">启用
            </a-button>
            <a-button v-if="item.status == 0" @click="changeStatus({ id: item.id, status: 1 })" class="active_btn" size="small"
              type="link">启用
            </a-button>
            <a-button v-if="item.status == 1" @click="changeStatus({ id: item.id, status: 0 })" class="active_btn" size="small"
              type="link">禁用
            </a-button>
            <a-button v-if="item.status == 1" @click="tableEdit(item)" class="active_btn" size="small" type="link">编辑
            </a-button>
            <a-button v-if="item.type == '7eba6a189e20e676b12ee0ff72c7c1d9'" @click="getPreviewExtendTestPaper(item)"
              class="active_btn" size="small" type="link">绑定试卷
            </a-button>
            <view-exam-modal :item="item" />
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal :visible="visible" title="试卷信息" @ok="modalSave" :destroyOnClose="true" @cancel="modalCancel">
      <a-form>
        <a-input type="hidden" v-model="form.id" />
        <a-form-item>
          <a-input v-model="form.name" placeholder="试卷名字" />
        </a-form-item>
        <a-form-item>
          <a-select v-model="form.semester_id" placeholder="学期" allow-clear>
            <a-select-option v-for="(item) in semesterList" :key="item.id" :value="item.id">{{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select v-model="form.grade_id" placeholder="年级" allow-clear>
            <a-select-option v-for="(item) in gradeList" :key="item.id" :value="item.id">{{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal :width="800" :visible="showPreviewExtendVisible" title="绑定自我检测试卷" @ok="bind_preview_extend"
      :destroyOnClose="true" @cancel="showPreviewExtendVisible = false">
      <a-form>
        <a-form-item style="text-align: center">
          <span style="font-size: 22px;">自我预习:{{ currTestPaperName }}</span>
        </a-form-item>
        <a-form-item style="text-align: center">
          <a-button style="margin-left: 5px;" type="primary" htmlType="submit"
            @click="qingchu_preview_extend({ id: changePreviewForm.source_id })">清除绑定</a-button>
          <a-input style="width: 200px" placeholder="搜索试卷" v-model="searchTestpaperKeyWords"
            @keyup.enter="getPreviewExtendTestPaper({ id: changePreviewForm.source_id, name: currTestPaperName })"></a-input>
          <a-button style="margin-left: 5px;" type="primary" htmlType="submit" icon="search"
            @click="getPreviewExtendTestPaper({ id: changePreviewForm.source_id, name: currTestPaperName })"></a-button>

        </a-form-item>
        <a-form-item>
          <a-table width="100%" :dataSource="previewExtendList" :rowKey="item => 'se' + item.testpaper_id"
            :pagination="false" :loading="loading">
            <a-table-column key="select_radio" title="选择">
              <template slot-scope="item">
                <a-radio-group v-model="changePreviewForm.bind_id">
                  <a-radio :value="item.testpaper_id" />
                </a-radio-group>
              </template>
            </a-table-column>
            <a-table-column key="testpaper_name" title="试卷名称" data-index="testpaper_name" />
          </a-table>

        </a-form-item>
      </a-form>
    </a-modal>
  </or-layout>
</template>

<script>

import ViewExamModal from '@/components/question/view-exam-modal.vue'
import ATableColumn from "ant-design-vue/es/table/Column";
import AFormItem from "ant-design-vue/es/form/FormItem";

export default {

  components: { AFormItem, ATableColumn, ViewExamModal },
  data() {
    return {
      data: [],
      pageinfo: { total: 1, current: 1, pageSize: 10 },
      loading: false,
      visible: false,
      gradeList: [],
      semesterList: [],
      searchFrom: {
        keyword: undefined,
        semester_id: undefined,
        grade_id: undefined,
        type_id: undefined,
        is_newtest: 0
      },
      showPreviewExtendVisible: false,
      form: {
        id: "",
        name: "",
        grade_id: "",
        semester_id: ""
      },
      typelist: [],
      //当前与习题的绑定信息
      currTestPaperName: undefined,
      previewExtendInfo: {
        testpaper_id: undefined,
        testpaper_name: undefined
      },
      changePreviewForm: {
        source_id: undefined,
        bind_id: undefined
      },
      //可以选择的试卷列表
      previewExtendList: [],
      searchTestpaperKeyWords: undefined
    };
  },
  mounted() {
    this.getGradeList();
    this.getSemesterList();
    this.getTestpaperTypeList();
    this.tableSearch();

  },
  methods: {
    bind_preview_extend() {
      this.loading = true;
      this.$axios
        .post("/api/QuestionTestpaper/setPreviewExtendTestPaper", { data: this.changePreviewForm })
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.showPreviewExtendVisible = false;
            this.$success({
              title: "成功",
              content: '绑定成功',
              okText: "确定",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    qingchu_preview_extend() {
      this.loading = true;
      this.$axios
        .post("/api/QuestionTestpaper/qingchuPreviewExtendTestPaper", { data: this.changePreviewForm })
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.showPreviewExtendVisible = false;

            this.$success({
              title: "成功",
              content: '清除成功',
              okText: "确定",
            });
            this.tableSearch();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getTestpaperTypeList() {
      this.$axios
        .post("/api/QuestionTestpaperType/index")
        .then((res) => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.typelist = res.data;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    view(id) {
      const url = "/question?exam=" + id;
      this.$router.push(url);
    },
    searchbtn() {
      this.getTableList(this.searchFrom);
    },
    getGradeList() {
      this.$axios
        .post("/api/BasicGrade/index")
        .then(res => {
          if (res.code == 200) {
            this.gradeList = res.data.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getSemesterList() {
      this.$axios
        .post("/api/BasicSemester/index")
        .then(res => {
          if (res.code == 200) {
            this.semesterList = res.data.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    selectItem(pid) {
      this.form.pid = pid;
    },
    changeStatus(data) {
      this.$axios
        .post("/api/QuestionTestpaper/edit", { data })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getTableList();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    onPaginationChange(item) {
      this.pageinfo.current = item.current;
      this.searchbtn();
    },
    tableSearch() {
      this.pageinfo.current = 1;
      this.getTableList(this.searchFrom);
    },
    getTableList(data) {
      this.loading = true;
      this.$axios
        .post("/api/QuestionTestpaper/index", {
          data,
          pageinfo: this.pageinfo
        })
        .then(res => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.data = res.data.data;
            this.pageinfo.total = res.data.pageinfo.total;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    tableEdit(item) {
      this.$router.push(`/question?exam=${item.id}`)
    },

    tableAdd() {
      this.form = {};
      this.visible = true;
    },
    tableDel(data) {
      let _this = this;
      this.$confirm({
        title: "删除权限",
        content: "确认删除当前权限吗?",
        okText: "确认",
        cancelText: "取消",
        onOk: function () {
          _this.$axios
            .post("/api/QuestionTestpaper/del", { data })
            .then(res => {
              if (res.code != 200) {
                _this.$error({
                  title: "错误",
                  content: res.msg,
                  okText: "确定"
                });
              } else {
                _this.searchbtn();
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      });
    },
    modalSave() {
      let _this = this;
      if (!this.form.grade_id) {
        _this.$error({
          title: "错误",
          content: "年级为必选项",
          okText: "确定"
        });
        return false;
      }
      if (!this.form.semester_id) {
        _this.$error({
          title: "错误",
          content: "学期为必选项",
          okText: "确定"
        });
        return false;
      }
      let url = "/api/QuestionTestpaper/edit";
      if (!this.form.id) {
        url = "/api/QuestionTestpaper/add";
      }
      this.$axios
        .post(url, { data: this.form })
        .then(res => {
          if (res.code != 200) {
            _this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            _this.tableSearch();
            _this.visible = false;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getPreviewExtendTestPaper(item) {
      this.loading = true;
      this.changePreviewForm.source_id = item.id;
      this.currTestPaperName = item.name;
      this.$axios
        .post('/api/QuestionTestpaper/getPreviewExtendTestPaper', { data: { id: item.id, keyword: this.searchTestpaperKeyWords } })
        .then(res => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.changePreviewForm.bind_id = "";
            if (res.data.currTestPaper != null) {
              this.changePreviewForm.bind_id = res.data.currTestPaper.testpaper_id;
            }
            this.previewExtendList = res.data.testPaperList;
            this.showPreviewExtendVisible = true;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    modalCancel() {
      this.visible = false;
    }
  }
};
</script>
<style>
.active_btn {
  margin-left: 5px;
}

.red {
  color: red;
}
</style>
